export default __webpack_public_path__ + "static/media/wallet.57cdd650.png";